// @flow

import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { createEpicMiddleware } from 'redux-observable';

import type { State } from './rootReducer';
import rootReducer, { initialState as defaultState } from './rootReducer';
import rootEpic from './rootEpic';
import Api from './Api';
import SlingApi from './SlingApi';

const epicMiddleware = createEpicMiddleware({
  dependencies: {
    Api,
    SlingApi
  }
});

const middleware = composeWithDevTools(applyMiddleware(epicMiddleware));

export default function configureStore(initialState: State = defaultState) {
  const store = createStore(rootReducer, initialState, middleware);
  epicMiddleware.run(rootEpic);
  return store;
}
